import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
} from "alm-react-components";
import { t } from "i18next";
import { ReactElement, useContext } from "react";
import { ActionType } from "../../assets/constants/constants";
import { AppContext } from "../../context/AppProvider";

export const AlertBox = () => {
  const { state, dispatch } = useContext(AppContext);
  const onCancle = () => {
    dispatch({type:ActionType.ALERT_BOX,payload:{
        visible:false,
        message:'',
        title:'',
        type:''
    }})
  };
  return (
    <AlertDialog open={state?.alertBox?.visible}>
        <AlertDialogContent className="bg-[#16171C] py-6 px-3 max-md:px-6 md:px-6 w-full text-center border border-primary overflow-hidden">
          <AlertDialogDescription className="text-sm text-muted-foreground flex max-sm:h-40 md:h-24 flex-col">
            <AlertBody type={state?.alertBox?.type} heading={state?.alertBox?.title} body={state?.alertBox?.message} />
          </AlertDialogDescription>
        <AlertDialogFooter className="lg:justify-center z-[1]">
          <AlertDialogAction
            onClick={() => onCancle()}
            className="w-full font-opensansSemiBold text-base"
          >
            {" "}
            {t("Common.gotIt")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};


type DialogModalProps = { 
  type?: string | null;
  heading?: ReactElement | any;
  body: ReactElement | any;
};

const AlertBody: React.FC<DialogModalProps> = ({
  body,
}) => {
  return (
      <div className="z-[1]">
        <div className="flex justify-center">
          <h3 className="text-xl font-barlowRegular text-white">{body}</h3>
        </div>
      </div> 
  );
};